import {fetchNews} from "./fetch-news.js";
import {renderNews} from "./render-news.js";
import {Lock, LockCurrentlyLockedError} from "./Lock.js";
import {initializeWebinarHandler} from "../webinar-registration/webinar-handler.js";
export class LoadMoreForm {
  constructor(container) {
    this.loadingLock = new Lock((isLocked) => this.handleLoadingLockChange(isLocked));
    this.form = container.querySelector("form.news-load-more__form");
    this.itemWrapper = container.querySelector(".news-load-more__item-wrapper");
    this.errorWrapper = container.querySelector("div.news-load-more__error_wrapper");
    this.totalCount = parseInt(this.form.dataset.newsCount);
    this.form.addEventListener("submit", (e) => this.onSubmit(e));
    this.updateSubmitButtonVisibility();
  }
  async onSubmit(event) {
    event.preventDefault();
    try {
      this.loadingLock.acquire();
      this.clearErrorMessages();
      const [response, payload] = await this.fetch(this.getCurrentOffset());
      if (!payload) {
        this.handleHTTPErrorResponse(response);
        return;
      }
      this.appendNews(payload);
    } catch (e) {
      console.error("Error occurred during load more form submit handling", e);
      if (e instanceof LockCurrentlyLockedError) {
        return;
      }
      this.handleClientError(e);
    } finally {
      this.updateSubmitButtonVisibility();
      this.loadingLock.release();
    }
  }
  handleHTTPErrorResponse(response) {
    this.defaultErrorMessage();
  }
  handleClientError(error) {
    this.defaultErrorMessage();
  }
  defaultErrorMessage() {
    this.errorWrapper.querySelector("p.news-load-more__general_error").hidden = false;
  }
  clearErrorMessages() {
    for (const child of this.errorWrapper.children) {
      if (!("hidden" in child)) {
        continue;
      }
      child.hidden = true;
    }
  }
  handleLoadingLockChange(isLocked) {
    for (const submitButton of this.getSubmitButtons()) {
      submitButton.disabled = isLocked;
    }
  }
  getSubmitButtons() {
    return this.form.querySelectorAll('[type="submit"].news-load-more__submit-button');
  }
  appendNews(payload) {
    payload.news.forEach((record) => {
      const registrationStatus = payload.settings.webinarUserDetails?.registrations[record.webinarId] ?? null;
      const newsElement = renderNews(record, registrationStatus);
      this.itemWrapper.append(newsElement);
      if (record.type === "webinar") {
        initializeWebinarHandler(newsElement);
      }
    });
  }
  getCurrentOffset() {
    return this.itemWrapper.childElementCount;
  }
  async fetch(offset) {
    const data = new FormData(this.form);
    data.set("tx_news_pi1[offset]", offset.toString());
    return await fetchNews(this.form.action, data);
  }
  updateSubmitButtonVisibility() {
    const shouldBeDisabled = this.totalCount <= this.getCurrentOffset();
    for (const submitButton of this.getSubmitButtons()) {
      submitButton.hidden = shouldBeDisabled;
    }
  }
}
